import { ElementRef, EventEmitter, Output } from '@angular/core';
import { Component, ViewChild, OnDestroy, Input, OnChanges, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { Subscription, BehaviorSubject, Subject, delay } from 'rxjs';

@Component({
  selector: 'ngx-taskboard-only-table',
  templateUrl: './taskboard-only-table.component.html',
  styleUrls: ['../../taskboard-table/taskboard-table.component.scss']
})
export class TaskboardOnlyTableComponent implements OnInit, OnChanges, OnDestroy {
  private subscription: Subscription = new Subscription();
  @ViewChild('table', { static: false }) table: MatTable<any>;
  @Input() columns = [];
  @Input() data: any;
  @Input() filter: BehaviorSubject<string> = new BehaviorSubject<string>('');
  @Input() edit: (event: any) => any;
  @Input() sortFromBackend: boolean = false;
  @Output() matSortChange = new EventEmitter();
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  public displayedColumns: string[] = [];
  public showSubtasksForTaskId;

  matTableDataSource = new MatTableDataSource<any>();

  private delayFocusSubject: Subject<void> = new Subject();
  @ViewChild('focusBlock') focusBlock: ElementRef;

  ngOnInit() {
    this.filter.subscribe((value: string) => {
      this.matTableDataSource.filter = (value.trim) ? value.trim().toLowerCase() : '';
    });
    this.matTableDataSource.sort = this.sort;
    if (this.sortFromBackend) {
      this.matTableDataSource.sortData = ((data, sort) => []);
    }
    this.subscription.add(this.delayFocusSubject.pipe(delay(100)).subscribe(() => {
      this.setFocus();
    }))
  }

  ngOnChanges() {
    const columns = [];
    for (const column of this.columns) {
      columns.push(column.fieldName);
    }
    // this.matTableDataSource.data = this.data;
    this.matTableDataSource = new MatTableDataSource(this.data);
    this.matTableDataSource.filterPredicate = (order: any, filter: string) => {
      const transformedFilter = filter.trim().toLowerCase();

      const listAsFlatString = (obj): string => {
        let returnVal = '';

        Object.values(obj).forEach((val) => {
          if (typeof val !== 'object') {
            returnVal = returnVal + ' ' + val;
          } else if (val !== null) {
            returnVal = returnVal + ' ' + listAsFlatString(val);
          }
        });

        return returnVal.trim().toLowerCase().replace(/ +(?= )/g, '');
      };

      return listAsFlatString(order).includes(transformedFilter);

    };
    this.displayedColumns = columns;
    if (this.sortFromBackend) {
      this.matTableDataSource.sortData = ((data, sort) => []);
    }
    this.delayFocusSubject.next();
  }

  toogleSubtaskList(taskId: number) {
    if (this.showSubtasksForTaskId != taskId) {
      this.showSubtasksForTaskId = taskId;
    } else {
      this.showSubtasksForTaskId = null;
    }
  }

  readonly isOverflow = (element: any) => {
    return (element.offsetHeight < element.scrollHeight
         || element.offsetWidth < element.scrollWidth);
  }

  countLines(element: any) {
    return Math.floor(100 - (element.offsetHeight * 100) / element.scrollHeight) + '% info';
  }

  trackByFn(index, item) {
    return index;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setFocus() {
    this.focusBlock?.nativeElement?.focus();
    this.focusBlock?.nativeElement?.click();
  }
}
